export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"m5 17.59 4.5-4.5 1.41 1.41-4.5 4.5H10v2H3v-7h2zM14 3h7v7h-2V6.41l-4.5 4.5-1.41-1.41 4.5-4.5H14z\"/>"
};